"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedPassport = void 0;
const getFormattedPassport = (input) => {
    if (input.length !== 10) {
        return '';
    }
    const result = input.match(/(\d{2})/g) || [];
    return result.slice(0, 2).join(' ') + ' ' + result.slice(2).join('');
};
exports.getFormattedPassport = getFormattedPassport;
